export default {"src":"/_next/static/media/judo.68071a15.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};